import {
  ILegalEntityResponseSchema,
  MCustomSelectProps,
} from '@monetize/types/app';
import { DEFAULT_PAGER } from '@monetize/types/common';
import React from 'react';
import { useGetListData } from '../../api/queryUtils';
import {
  ILegalEntitiesSelector,
  selectLegalEntities,
} from '../../api/selectors';
import { MCustomSelect } from './MCustomSelect/MCustomSelect';
import { MainSearchInputV2 } from './MCustomSelect/components/MainSearchInputV2';

interface MLegalEntitySelectProps extends Omit<
  MCustomSelectProps,
  | 'items'
  | 'itemTitle'
  | 'itemValue'
  | 'loading'
  | 'defaultValue'
  | 'showQueryInput'
> {}

export const MLegalEntitySelect = React.forwardRef<
  any,
  MLegalEntitySelectProps
>((props, ref) => {
  const { data: legalEntityData, isLoading } = useGetListData<
    ILegalEntityResponseSchema,
    ILegalEntitiesSelector
  >(
    'legalEntities',
    { config: DEFAULT_PAGER },
    {
      select: selectLegalEntities,
      isGetAll: true,
    },
  );

  return (
    <MCustomSelect
      placeholder="Legal Entity"
      ref={ref}
      itemTitle="name"
      itemValue="id"
      items={legalEntityData?.legalEntities}
      loading={isLoading}
      defaultValue={legalEntityData?.defaultLegalEntity?.id}
      useMainInputAsSearchInput
      MainInputComponent={MainSearchInputV2}
      {...props}
    />
  );
});
